import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import BgImage from "../../Assets/Images/hero1.webp";

export default function Register({ isOpen, onClose }) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
    address: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/users/register`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      toast.success("Registration successful!");
      onClose();
    } catch (err) {
      if (err.response) {
        toast.error(err.response.data.message || "Registration failed.");
      } else if (err.request) {
        toast.error("Network error. Please check your connection.");
      } else {
        toast.error("An unexpected error occurred.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Background */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `
      radial-gradient(circle at center, rgba(0,0,0,0) 60%, rgba(0,0,0,0.3) 100%),
      url(${BgImage})
    `,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundBlendMode: "darken",
        }}
      />

      {/* Glassmorphic Card */}
      <div
        className="relative z-10 w-full max-w-md p-8 rounded-2xl shadow-2xl
                   bg-white/5 backdrop-blur-3xl border border-white/20
                   animate-fade-in"
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white/70 hover:text-red-400 text-2xl transition-colors"
        >
          &times;
        </button>
        <h2
          className="text-3xl font-bold mb-6 text-center 
             bg-gradient-to-r from-blue-400 to-green-400 
             bg-clip-text text-transparent drop-shadow-lg"
          style={{
            WebkitTextStroke: "1px black",
          }}
        >
          Create an Account
        </h2>


        {/* Form */}
        <form onSubmit={handleRegister} className="space-y-4">
          {[
            { label: "Full Name", name: "name", type: "text", required: true },
            { label: "Email Address", name: "email", type: "email" },
            { label: "Phone Number", name: "phoneNumber", type: "tel", required: true },
            { label: "Password", name: "password", type: "password", required: true },
          ].map((field, idx) => (
            <div key={idx} className="space-y-2">
              <label className="block text-sm font-semibold text-white">
                {field.label}
              </label>
              <input
                name={field.name}
                type={field.type}
                value={formData[field.name]}
                onChange={handleChange}
                required={field.required}
                className="w-full px-4 py-2 rounded-lg border border-white/20 bg-white/10
                           text-white placeholder-white/50 focus:outline-none focus:ring-2
                           focus:ring-orange-400 transition-all duration-300"
              />
            </div>
          ))}

          {/* Address */}
          <div>
            <label className="block text-sm font-semibold text-white">Address</label>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              rows={1}
              className="w-full px-4 py-2 rounded-lg border border-white/20 bg-white/10
                         text-white placeholder-white/50 focus:outline-none focus:ring-2
                         focus:ring-orange-400 transition-all duration-300"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-gradient-to-r from-orange-500 to-pink-500 hover:opacity-90
                       text-white py-2 rounded-lg font-semibold transition duration-300
                       flex items-center justify-center shadow-lg shadow-orange-500/30"
          >
            {isLoading ? (
              <>
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 
                       0 5.373 0 12h4zm2 5.291A7.962 
                       7.962 0 014 12H0c0 3.042 1.135 
                       5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Processing...
              </>
            ) : (
              "Register"
            )}
          </button>
        </form>

        {/* Footer */}
        <p className="mt-4 text-sm text-center text-white/80">
          Already have an account?{" "}
          <span
            className="text-orange-300 cursor-pointer hover:underline"
            onClick={() => {
              onClose();
              navigate("/user-login");
            }}
          >
            Login
          </span>
        </p>
      </div>
    </div>
  );
}
